import { useEffect, useState } from 'react'

// A caminho/chegando: 4s, pra caixinha andar quase junto com o celular (o
// Traccar manda a cada 5s). O acesso do pedido é conferido no orion no máximo
// 1x/min (cache do betracking) e a rota 1x/45s, então isso não pesa lá atrás.
const INTERVALO_MS = 4000
// Agendada ou coletando: não há carro indo pro endereço, não precisa de 4s.
const INTERVALO_SEM_MAPA_MS = 60000
const ESPERA_MAX_MS = 60000
const INTERVALO_ESCONDIDA_MS = 30000
const FIM = ['delivered', 'cancelled']
const SEM_MAPA = ['scheduled', 'collecting']

// Busca a entrega de tempos em tempos e para sozinho quando ela termina —
// depois de entregue não tem mais posição pra mostrar. 401/404 = não há
// entrega pra este usuário/link: some da tela sem erro. Com a aba escondida
// consulta a cada 30s (o título avisa); volta ao ritmo normal na hora em
// que a aba reaparece.
// Erro de rede/servidor espaça as tentativas (4s, 8s, 16s, 32s, até 1 min).
export default function useLiveDelivery(buscar) {
  const [view, setView] = useState(null)
  const [inexistente, setInexistente] = useState(false)
  const [falhando, setFalhando] = useState(false)

  useEffect(() => {
    let vivo = true
    let timer = null
    let parado = false
    let falhas = 0
    let emVoo = false
    // Trocou de pedido/link com o componente montado: não pode sobrar a
    // entrega (nem o link de compartilhar) do anterior na tela.
    setView(null)
    setInexistente(false)
    setFalhando(false)

    // Aba escondida: segue consultando, mas devagar (30s) — o título da aba
    // ("🔔 Chegou!") avisa quem está em outra aba sem martelar o servidor.
    const agendar = (ms) => {
      clearTimeout(timer)
      timer = null
      if (!vivo || parado) return
      timer = setTimeout(passo, document.hidden ? Math.max(ms, INTERVALO_ESCONDIDA_MS) : ms)
    }

    const passo = async () => {
      timer = null
      let espera = INTERVALO_MS
      emVoo = true
      try {
        const v = await buscar()
        if (!vivo) return
        falhas = 0
        setFalhando(false)
        setView(v)
        if (FIM.includes(v.status)) {
          parado = true
          return
        }
        if (SEM_MAPA.includes(v.status)) espera = INTERVALO_SEM_MAPA_MS
      } catch (e) {
        if (!vivo) return
        if ([401, 404].includes(e?.response?.status)) {
          parado = true
          setView(null)
          setInexistente(true)
          return
        }
        falhas += 1
        setFalhando(true)
        espera = Math.min(ESPERA_MAX_MS, INTERVALO_MS * 2 ** (falhas - 1))
      } finally {
        emVoo = false
      }
      agendar(espera)
    }

    const aoTrocarVisibilidade = () => {
      if (parado || emVoo) return
      if (document.hidden) {
        agendar(INTERVALO_ESCONDIDA_MS)
      } else {
        // Voltou pra aba: atualiza na hora (sem esperar os 30s).
        clearTimeout(timer)
        timer = null
        passo()
      }
    }

    document.addEventListener('visibilitychange', aoTrocarVisibilidade)
    passo()
    return () => {
      vivo = false
      clearTimeout(timer)
      document.removeEventListener('visibilitychange', aoTrocarVisibilidade)
    }
  }, [buscar])

  return { view, inexistente, falhando }
}
